import React, { FunctionComponent } from 'react';
import { FinanceType } from '@upstart/harmony/lib/legos/constants';
import { DealerLaunchStepProps } from '../types';
import styles from '../styles.module.scss';
import { DealerLaunchFormCardLayout } from '../DealerLaunchFormCardLayout';
import { useLaunchpadForm } from '../../../hooks/useLaunchpadForm';
import { Radio } from '../../Input/Radio/Radio';

export const DealerLaunchLeaseCreditCopyOver: FunctionComponent<DealerLaunchStepProps> = ({
  dealer,
  prevStep,
  nextStep,
}) => {
  const form = useLaunchpadForm({
    defaultValues: {
      differentCreditTiers: true,
    },
  });
  const onSubmit = async (data: { differentCreditTiers: boolean }) => {
    const dealerUpdate = data.differentCreditTiers
      ? {
          launchpad: { status: { finishedPricingLeaseCopyOver: true } },
        }
      : {
          launchpad: {
            creditPricing: {
              [FinanceType.LEASE]: {
                creditTiers:
                  dealer.launchpad?.creditPricing?.[FinanceType.PURCHASE]
                    ?.creditTiers,
              },
            },
            status: {
              finishedPricingLeaseCopyOver: true,
            },
          },
        };
    // overwrite all the apr configs for different client types and conditions
    await nextStep(dealerUpdate);
  };
  return (
    <DealerLaunchFormCardLayout
      className={styles.creditTierStep}
      form={form}
      title="Which Credit Tiers Do You Use Online?"
      prevStep={prevStep}
      onFormSubmit={onSubmit}
    >
      <div>
        <h1>Do you have different credit tiers for leases?</h1>
      </div>
      <Radio
        className="flex-column"
        name="differentCreditTiers"
        options={[
          {
            label: 'Yes',
            value: true,
          },
          {
            label: 'No',
            value: false,
          },
        ]}
        form={form}
      />
    </DealerLaunchFormCardLayout>
  );
};
